export default "__VITE_ASSET__Dc0EV9zT__"